export default __webpack_public_path__ + "static/media/LogoPdf.5c49b031.jpg";